import { supabase } from "../lib/api";

type UpdateLinkLikesProps = {
  newLikesCount: number;
  linkId: number;
};

export const updateLinkLikes = async (props: UpdateLinkLikesProps) => {
  const { newLikesCount, linkId } = props;
  // ok = 200
  return await supabase
    .from("links")
    .update({ likes: newLikesCount })
    .eq("id", linkId)
    .select();
};
